import React from "react";
import Styled from "@emotion/styled";
import BrollVid from "../Broll/BrollVid";

import environment from "../imgs/environmentWith.png";

const How = (props) => {
  const Container = Styled.div`
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        min-width: 900px;

        @media (max-width: 1100px) {
          min-width: 0;
          flex-direction: column;
        }
    `;
  const Subheader = Styled.div`
        font-size: 3em;
        color: #35a1f9;
        margin-bottom: 2vh;
    `;
  const Side = Styled.div`
        display: flex;
        flex-direction: column;
        
    `;
  const Title = Styled.div`
    color: #000000;
    font-size: 5em;
    font-weight: 600;
    @media (max-width: 1100px) {
      font-size: 1.5em;
    }
  `;

  const Text = Styled.div`
    font-size: 1.5vw;
    width: 22vw;
    line-height: 1.4em;

    @media (max-width: 1100px) {
      width: 100%;
      min-width: 0;
      font-size: 1em;
    }
  `;
  return (
    <div className={props.isVisible ? "animated fadeIn" : "animated fadeOut"}>
      {/* <BrollVid></BrollVid> */}
      <Title>How It Works</Title>
      <Subheader>Instructions</Subheader>
      <Container>
        <Side>
          <Text>
            Using neural networks, the user can vary the performance of the AI
            by choosing the amount of iterations to train the AI before it goes
            through the intersection. The user can also choose Free Play mode,
            which will give the controls over from the AI to the user, and using
            WASD they can try out the environment themselves. The checkmark
            beside the Start button enables locking, which maintains the
            iteration
          </Text>
        </Side>

        <Side>
          <Text>
            after every round, as opposed to having it unchecked which will
            increase the iteration by 5 after every round and retrain the neural
            network. Designing the physics engine was the first step. Originally
            I assumed this would be the easiest phase, however, I was quick to
            realize this would be one of the most complex aspects of
            development. After lots of planning and trials, I came up with
          </Text>
        </Side>

        <Side>
          <Text>
            original turning calculations that would interact with its
            acceleration and deceleration physics. As the development
            progressed, it was time to incorporate artificial intelligence. A
            supervised learning method was chosen to train the neural networks.
            This works by constantly telling the AI if it is correct, and
            comparing its results to the desired output then making adjustments
            accordingly.
          </Text>
        </Side>
      </Container>
    </div>
  );
};
export default How;
